<div fxLayout="column" fxLayoutAlign="center center">
    <h1 fxFlex>
        Please connect to Discord</h1>

    <div fxFlex class="widgetHeader-2Hz_Ln">
        <div class="discord-logo widgetLogo-6zH6Nv"></div>
        <div fxLayout="column" class="button-container">
            <div class="button-container">
                <button (click)="connect()" class="widgetBtnConnect-2fvtGa">Connect</button>
                <!-- <a href="http://localhost:8899/discord/login" target="_blank" class="widgetBtnConnect-2fvtGa">Connect</a> -->
            </div>
            <div class="button-container">
                <button (click)="close()" class="widgetBtnConnect-2fvtGa">I'm not on Discord yet</button>
                <!-- <a href="http://localhost:8899/discord/login" target="_blank" class="widgetBtnConnect-2fvtGa">Connect</a> -->
            </div>
        </div>
    </div>
</div>